import React from 'react';

import facebookIcon from '_images/facebook-icon.png';
import instagramIcon from '_images/instagram-icon.svg';
import linkedinIcon from '_images/LinkedIn.svg';
import tiktokIcon from '_images/TikTok.svg';
import youtubeIcon from '_images/YouTube.svg';

export default function SocialLinksSection() {
  return (
    <div className="order-2 lg:order-3 flex justify-end gap-2.5">
      <a
        href="https://www.facebook.com/oneshiftsg"
        target="_blank"
        rel="noreferrer"
      >
        <img src={facebookIcon} className="w-8 h-8" alt="Facebook" />
      </a>
      <a
        href="https://www.instagram.com/oneshift/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={instagramIcon} className="w-8 h-8" alt="Instagram" />
      </a>
      <a
        href="https://www.tiktok.com/@oneshiftbycarousell"
        target="_blank"
        rel="noreferrer"
      >
        <img src={tiktokIcon} className="w-8 h-8" alt="Tiktok" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCB9O9BB4DnmcXqpif-P9GMg"
        target="_blank"
        rel="noreferrer"
      >
        <img src={youtubeIcon} className="w-8 h-8" alt="Youtube" />
      </a>
      <a
        href="https://www.linkedin.com/company/oneshift-by-carousell/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={linkedinIcon} className="w-8 h-8" alt="LinkedIn" />
      </a>
    </div>
  );
}
